// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"20d03ea9","251":"f7e3b02d","498":"b16c349d","608":"9ab615c3","703":"507ba7cb"}[chunkId] + ".chunk.js";
};